var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentfulSelect',{attrs:{"label":"Feldtyp","required":true,"options":_vm.ATTRIBUTE_TYPE_SELECTION_ITEMS,"value":_vm.selectedAttributeSelectionItem.value},on:{"input":_vm.handleTypeSelection}})
}
var staticRenderFns = []

export { render, staticRenderFns }